module.exports = __webpack_public_path__ + "img/EY__wavespace_xl.76016202.png";